export async function withRetry<T>(
  fn: () => Promise<T>,
  attempts = 3,
  baseDelayMs = 2000
): Promise<T> {
  let lastErr: unknown
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn()
    } catch (e) {
      lastErr = e
      if (i < attempts - 1) {
        const wait = baseDelayMs * Math.pow(2, i)
        await new Promise((r) => setTimeout(r, wait))
      }
    }
  }
  throw lastErr
}
